import { createAsyncThunk } from '@reduxjs/toolkit';

import { show } from 'src/common/primitives/Toast/toast.slice';
export const execTripMenuAction = createAsyncThunk(
  'dispatcher/trip-menu/exec-action',
  async function execTripMenuActionImpl(
    {
      action,
      successMessage,
      errorMessage,
      serverErrorMessageFormatter,
    }: {
      action: () => Promise<void>;
      successMessage: string;
      errorMessage: string | null;
      serverErrorMessageFormatter?: (error: any) => string | null;
    },
    { dispatch }
  ) {
    try {
      await action();
      dispatch(
        show({
          description: successMessage,
          type: 'success',
        })
      );
    } catch (e) {
      // TODO: provide an onError hook to allow showing errors in modals
      const serverErrorMessage =
        (serverErrorMessageFormatter && serverErrorMessageFormatter(e)) || null;

      if (serverErrorMessage) {
        dispatch(
          show({
            description: serverErrorMessage,
            type: 'error',
          })
        );
        return;
      }

      if (errorMessage) {
        dispatch(
          show({
            description: errorMessage,
            type: 'error',
          })
        );
      }
    }
  }
);
